<div class="note-view d-flex align-items-center info">
  <span class="svg-icon icon-note-view me-6" inlineSVG="{{ ASSETS_ICON.IC_INFORMATION }}"></span>
  <div class="text-black font-14 w-100 d-flex justify-content-between">
    <p class="mb-0">{{ data.value?.message }}</p>
    <p (click)="detailRejectProduct()" class="mb-0 cursor-pointer fw-bold text-primary"><u>Lihat Detail</u></p>
  </div>
</div>

<app-modal #modalRejectProduct [modalConfig]="modalConfigRejectProduct" [modalOptions]="{ size: 'md' }">
  <ng-container *ngIf="data | async as data">
    <app-note-view [color]="'secondary'" [icon]="ASSETS_ICON.IC_INFORMATION_GREY" [text]="data.title" />

    <div *ngIf="data.rejected_by_central_admin?.reason" class="mb-6">
      <p class="font-16 fw-bold">Ditolak Admin Pusat</p>
      <div class="row font-14">
        <div class="col-md-4 d-flex justify-content-between">
          <p class="mb-0 text-gray-700">Produk</p>
          <p class="mb-0">:</p>
        </div>
        <div class="col-md-8 px-0">
          <p *ngFor="let item of data.rejected_by_central_admin.products" class="mb-0">{{ isSpm ? item : item.product_name + ' (' + item.qty + ' ' + item.qty_type + ')' }}</p>
        </div>

        <div class="col-md-4 mt-3 d-flex justify-content-between">
          <p class="mb-0 text-gray-700">Alasan</p>
          <p class="mb-0">:</p>
        </div>
        <div class="col-md-8 px-0 mt-3">
          <p class="mb-0">{{ data.rejected_by_central_admin.reason }}</p>
        </div>
      </div>
      <hr />
    </div>

    <div *ngIf="!isSpm && data.not_loaded?.reason" class="mb-6">
      <p class="font-16 fw-bold">Tidak Dimuat</p>
      <div class="row font-14">
        <div class="col-md-4 d-flex justify-content-between">
          <p class="mb-0 text-gray-700">Produk</p>
          <p class="mb-0">:</p>
        </div>
        <div class="col-md-8 px-0">
          <p *ngFor="let item of data.not_loaded?.products" class="mb-0">{{ isSpm ? item : item.product_name + ' (' + item.qty + ' ' + item.qty_type + ')' }}</p>
        </div>

        <div class="col-md-4 mt-3 d-flex justify-content-between">
          <p class="mb-0 text-gray-700">Alasan</p>
          <p class="mb-0">:</p>
        </div>
        <div class="col-md-8 px-0 mt-3">
          <p class="mb-0">{{ data.not_loaded?.reason }}</p>
        </div>
      </div>
    </div>

    <div class="mb-6" *ngIf="!isSpm && !!data.not_fulfilled?.length">
      <div class="row font-14">
        <div class="col-md-4 d-flex justify-content-between">
          <p class="mb-0 text-gray-700">Produk</p>
          <p class="mb-0">:</p>
        </div>
        <div class="col-md-8 px-0">
          <p *ngFor="let item of data.not_fulfilled" class="mb-0">{{ item }}</p>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isSpm && data.not_loaded" [ngTemplateOutlet]="notLoadedBacktoSO" [ngTemplateOutletContext]="{ data: data.not_loaded, reason: data.reason }">
    </ng-container>
  </ng-container>
</app-modal>

<ng-template #notLoadedBacktoSO let-data="data">
  <div class="mb-6">
    <p class="font-16 fw-bold">Tidak Dimuat</p>
    <div class="row font-14">
      <div class="col-md-4 d-flex justify-content-between">
        <p class="mb-0 text-gray-700">Produk</p>
        <p class="mb-0">:</p>
      </div>
      <div class="col-md-8 px-0">
        <p *ngFor="let item of data.products" class="mb-0">{{ item }}</p>
      </div>

      <div class="col-md-4 mt-3 d-flex justify-content-between">
        <p class="mb-0 text-gray-700">Alasan</p>
        <p class="mb-0">:</p>
      </div>
      <div class="col-md-8 px-0 mt-3">
        <p class="mb-0">{{ data.reason ? data.reason : '-' }}</p>
      </div>
    </div>
  </div>
</ng-template>
